<template>
  <div>
    <a-modal
      title="编辑任务"
      :visible="visible"
      :width="600"
      ok-text="确认"
      cancel-text="取消"
      @ok="ok"
      @cancel="cancel"
    >
      <a-form :form="form" v-bind="formLayout">
        <a-form-item label="资源库">
          <a-select
            mode="multiple"
            placeholder="请选择资源库"
            v-decorator="[
              'pathIds',
              { rules: [{ required: true, message: '请选择资源库' }] },
            ]"
          >
            <a-select-option
              v-for="p in edittaskdata"
              :key="p.id"
              :value="p.id"
            >
              {{ p.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        
        <a-form-item label="image_height">
          <a-input v-decorator="['imageHeight']" />
        </a-form-item>
        <a-form-item label="image_width">
          <a-input v-decorator="['imageWidth']" />
        </a-form-item>
        <a-form-item label="是否保持图片比例">
             <a-checkbox :checked="iskeepRatio"  @change="changekeepRatio">
                
              </a-checkbox>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { requestUrl } from "@utils/request_url";
import request from "@utils/request";
import pick from 'lodash.pick'
const fields = [
    'pathIds',
    'imageHeight',
    'imageWidth'
]
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    editdata: {
      type: Object,
      required: true,
    },
    edittaskdata: {
      type: Array,
      required: true,
    },
    editId: {
        type: Number,
        required: true
    },
    // model: {
    //   type: Object,
    //   default: () => null,
    // },
  },
  data() {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
        model:{},
        form: this.$form.createForm(this),
        iskeepRatio:null
    };
  },
  created() {
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  // mounted(){
  //     this.initInformation()
  // },
  methods: {
    ok() {
      const that = this
      this.form.validateFields((error, values) => {
        if(!error) {
          var commitValue = {
            imageHeight: values.imageHeight,
            imageWidth: values.imageWidth,
            pathIds: values.pathIds,
            id: that.editId,
            keepRatio: that.iskeepRatio
          }
          this.$emit("ok", commitValue);
        }
      })
      
    },
    cancel() {
      this.$emit("cancel");
    },
    initInformation(){
        const that = this
        this.loadConfig(that.editId).then((res) => {
          console.log(res);
            this.model = {
              imageHeight: res.data.fileHeight,
              imageWidth: res.data.fileWidth,
              pathIds: res.data.testFilePathIds,
            }
            this.iskeepRatio = res.data.keepRatio
        })
    },
    async loadConfig(id) {
      const resultData = null;
      const dataUrl = requestUrl + "train/rest/test_task/get/" + id;
      try {
        const res = await request({
          url: dataUrl,
          method: "get",
        });

        return res;
      } catch (err) {
        console.log(err);
      }
      return resultData;
    },
    changekeepRatio(value) {
      this.iskeepRatio = value.target.checked
    }
  },
  watch: {
      visible(newv, oldv) {
        this.model = {}
        this.keepRatio = false
        this.initInformation()
      }
  }
};
</script>

<style lang="scss" scoped>
</style>